import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  AddManualPaymentPayload,
  IPaymentMethodsSettings,
  UpdateManualPaymentPayload,
} from '../types/payment-methods.type';

export const paymentMethodsApi = createApi({
  reducerPath: 'paymentMethodsApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin`),
  endpoints: (builder) => ({
    addManualPayment: builder.mutation<ApiResponse<IPaymentMethodsSettings>, AddManualPaymentPayload>({
      query: (payload) => ({
        url: `/companies/${payload.company_id}/payments/manual`,
        method: 'POST',
        body: payload,
      }),
    }),
    updatedManualPayment: builder.mutation<ApiResponse<IPaymentMethodsSettings>, UpdateManualPaymentPayload>({
      query: (payload) => ({
        url: `/companies/${payload.company_id}/payments/manual/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
    }),
  }),
});

export const { useAddManualPaymentMutation, useUpdatedManualPaymentMutation } = paymentMethodsApi;
